import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'oir-collapsible-card',
  templateUrl: './collapsible-card.component.html',
  styleUrls: ['./collapsible-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleCardComponent {
  @Input() collapsed = true;
  @Input() enableCollapse = true;

  @Output() isCollapsed = new EventEmitter<boolean>();
  @Output() onOpen: EventEmitter<void> = new EventEmitter();
  @Output() onClose: EventEmitter<void> = new EventEmitter();
  @Output() onToggle: EventEmitter<void> = new EventEmitter();

  toggle(event: KeyboardEvent = null): void {
    if (event) {
      event.stopImmediatePropagation();
    }

    this.collapsed = !this.collapsed;
    this.isCollapsed.emit(this.collapsed);
    this.onToggle.emit();
    if (this.collapsed) {
      this.onClose.emit();
    } else {
      this.onOpen.emit();
    }
  }
}
